module.exports = __webpack_public_path__ + "img/Image5.dd0fdc7c.png";